import React from 'react'
import { Grid, TextField } from '@mui/material'
import NumberFormat from 'react-number-format'
import JobRadioGroup from 'components/Drawers/JobDrawer/JobRadioGroup'
import { salaryTypeOptions } from 'components/Drawers/JobDrawer/constants'
import { getCurrencySymbol } from 'pages/Jobs/helpers'
import { CURRENCY_BY_COUNTRY } from 'data/enums'

const CompensationSection = ({ values, setState, showError, required = true, country }) => {
  const currencyPrefix = getCurrencySymbol(CURRENCY_BY_COUNTRY[country] || 'USD')
  const hasSalaryRangeError =
    values.salaryMin && values.salaryMax && values.salaryMin > values.salaryMax

  const minSalaryError = hasSalaryRangeError
    ? 'Min salary must be less than Max salary'
    : required && showError && !values.salaryMin
      ? 'Required'
      : ''

  const maxSalaryError = hasSalaryRangeError
    ? 'Min salary must be less than Max salary'
    : required && showError && !values.salaryMax
      ? 'Required'
      : ''

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JobRadioGroup
          required={required}
          label='Salary Type'
          name='salaryType'
          value={values.salaryType}
          options={salaryTypeOptions}
          setState={setState}
          showError={showError}
        />
      </Grid>
      {values.salaryType && (
        <Grid item xs={12} container spacing={2}>
          <Grid item xs={6}>
            <NumberFormat
              label={required ? 'Min Salary *' : 'Min Salary'}
              value={values.salaryMin || ''}
              onValueChange={({ value }) => {
                if (/^\d*$/.test(value)) {
                  setState('salaryMin', value ? parseInt(value, 10) : null)
                }
              }}
              thousandSeparator
              prefix={currencyPrefix}
              required={required}
              customInput={TextField}
              fullWidth
              size='small'
              error={!!minSalaryError}
              helperText={minSalaryError}
            />
          </Grid>
          <Grid item xs={6}>
            <NumberFormat
              label={required ? 'Max Salary *' : 'Max Salary'}
              value={values.salaryMax || ''}
              onValueChange={({ value }) => {
                if (/^\d*$/.test(value)) {
                  setState('salaryMax', value ? parseInt(value, 10) : null)
                }
              }}
              thousandSeparator
              prefix={currencyPrefix}
              required={required}
              customInput={TextField}
              fullWidth
              size='small'
              error={!!maxSalaryError}
              helperText={maxSalaryError}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default CompensationSection
